import { PresentationChip } from "@itandi/itandi-bb-ui/PresentationChip";
import { DEAL_TYPE_LABEL } from "~/models/Deal";
import type { Subtype } from "~/models/Subtype";

type Props = {
	dealSubtype: Subtype | null;
	dealType: "restoration" | "repair" | "other";
};
export function DealTypeLabel({ dealType, dealSubtype }: Props) {
	const typeLabelText = dealSubtype?.name ?? DEAL_TYPE_LABEL[dealType];

	return <PresentationChip variant="gray">{typeLabelText}</PresentationChip>;
}
